import SaveQueryModal from './SaveQueryModal';

export default SaveQueryModal;
